module.exports = __webpack_public_path__ + "static/media/group.f117ec6e.png";